'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$9(ps$51) {
  this.a78 = null;
  this.a78 = ps$51;
}
export { $c_Lmealorama_jsonCodecs$package$$anon$9 as $c_Lmealorama_jsonCodecs$package$$anon$9 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$9.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$9;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$9() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$9 as $h_Lmealorama_jsonCodecs$package$$anon$9 };
$h_Lmealorama_jsonCodecs$package$$anon$9.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a78.a.length;
});
$p.g = (function(i) {
  return this.a78.a[i];
});
var $d_Lmealorama_jsonCodecs$package$$anon$9 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$9, "mealorama.jsonCodecs$package$$anon$9", ({
  KC: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$9 as $d_Lmealorama_jsonCodecs$package$$anon$9 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$9.js.map
